import { Injectable } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import { AppReady } from './app-init.action';

@Injectable({
  providedIn: 'root',
})
export class AppInitFacade {
  constructor(private actions$: Actions) {}

  appReady$ = this.actions$.pipe(ofType(AppReady));
}
